import { motion } from 'framer-motion';

export default function EmptyState({
    icon = 'bi-inbox',
    title = 'No data found',
    description = 'Get started by creating your first item.',
    action = null,
    className = ''
}) {
    return (
        <motion.div
            className={`text-center py-5 ${className}`}
            initial={{ opacity: 0, scale: 0.95 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ duration: 0.3 }}
        >
            <div
                className="mx-auto mb-4 d-flex align-items-center justify-content-center rounded-circle bg-light"
                style={{ width: '120px', height: '120px' }}
            >
                <i className={`bi ${icon} display-3 text-muted`}></i>
            </div>
            <h5 className="fw-semibold text-dark mb-2">{title}</h5>
            <p className="text-muted mb-4 mx-auto" style={{ maxWidth: '300px' }}>{description}</p>
            {action}
        </motion.div>
    );
}
